module.exports = __webpack_public_path__ + "img/Instagram.cd6a342c.png";